import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { EPlatformType, IError } from '@unfoldrtech/portal-mic'
import {
  EParamChannelTypeGlobal,
  ETimeBucketType,
  EReportingTimeWindow,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { coreAPI } from '../services/coreAPI'
import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAProductsReportChartFilters,
  TPPRetailerId,
  TSPProductsReportChartFilters,
} from '../models/types'
import { IReportingProductsChartResponse } from '../models'

export default function useGetRetailerReportingProductsChartV3({
  retailerId,
  advertiserId,
  campaignId,
  adGroupId,
  channelType,
  productId,
  platformType,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}:
  | {
      enabled?: boolean
      suspense?: boolean
    } & (TSPProductsReportChartFilters | TDAProductsReportChartFilters) &
      TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingProductsChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingProductsChart_${channelType}_${retailerId}_${advertiserId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPI.v2RetailerReporting().getRetailerProductsReportChart(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        adGroupId,
        channelType as EParamChannelTypeGlobal,
        productId,
        platformType as unknown as EPlatformType,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
